import { Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import { cn } from "@/libs/cn";
import type { SectorDraft, SlotIndex } from "../../selector/types";
import { SuggestedMark } from "./primitives";

const I18N = "taxonomy.sector" as const;

/**
 * Says where the suggested rows of a sector come from, with one of three
 * texts picked by the source. It shows only if the sector has at least one
 * suggested row, and it never promises that a removed suggestion will not
 * come back (AC3).
 */
export const SuggestedLegend = (props: {
  draft: SectorDraft;
  index: SlotIndex;
  class?: string;
}) => {
  const { t } = useI18n();
  const hasSuggested = () =>
    props.draft
      .subOptions(props.index)
      .some((option) => option.origin === "suggested");

  return (
    <Show when={hasSuggested()}>
      <p
        class={cn(
          "flex items-start gap-1.5 text-xs text-foreground/70",
          props.class,
        )}
      >
        <SuggestedMark class="mt-0.5 text-ring" />
        <span>{t(`${I18N}.legend.${props.draft.source ?? "jev"}`)}</span>
      </p>
    </Show>
  );
};
